import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-amount-display',
    templateUrl: './amount-display.component.html',
    styleUrls: ['./amount-display.component.scss'],
    standalone: false
})
export class AmountDisplayComponent {
  @Input() heading: string;
  @Input() dollarAmount: number;
  @Input() subtitle: string;
  @Input() displayDecimalSeperator: boolean = true;
  @Input() testId?: string;
}
